import { BaseFooter } from '../internals';
import { getSwitchAuthenticatorLink } from '../utils/LinksUtil';

export default BaseFooter.extend({
  links() {
    return getSwitchAuthenticatorLink(this.options.appState);
  }
});



// WEBPACK FOOTER //
// ./src/v2/view-builder/components/AuthenticatorFooter.js